import { MenuResponse, SiteSettingsResponse } from "../shared/settings";
import { jsonApi } from "./jsonApi";

export const getSiteSettings = (id: string) => jsonApi<SiteSettingsResponse>(`config_pages/site_settings/${id}`);
export const getMenu = (menuName: string) => jsonApi<MenuResponse>(`menu_items/${menuName}`);
